import React, { ReactNode } from 'react';
import { Callout, DirectionalHint, IStackStyles, Stack } from '@fluentui/react';
import { useStyles } from './index.styles';

interface LookUpCalloutProps {
  onDismiss?: () => void;
  targetID: string;
  lookUpCalloutWidth?: number;
  children?: ReactNode;
  lookupCalloutStyles?: IStackStyles;
}

export const LookUpCallout: React.FC<LookUpCalloutProps> = ({
  onDismiss,
  targetID,
  lookUpCalloutWidth,
  lookupCalloutStyles,
  children,
}) => {
  const styles = useStyles();
  return (
    <Callout
      onDismiss={onDismiss}
      gapSpace={10}
      isBeakVisible={false}
      className={styles.callout}
      directionalHint={DirectionalHint.bottomLeftEdge}
      target={targetID}
      style={{ width: lookUpCalloutWidth }}
    >
      <Stack
        // className={styles.searchAreaContainer}
        style={{ width: lookUpCalloutWidth }}
        styles={lookupCalloutStyles}
      >
        <Stack>{children}</Stack>
      </Stack>
    </Callout>
  );
};
